import { atom, selector } from 'recoil';
import { TelecomTypeState } from 'src/recoil/join';
import { JoinTerms, PartnerEventInfo, PartnerInfo } from 'src/types/type';
import { defaultUiStyle } from 'src/utils/UiStyle';

export const LoadingState = atom<boolean>({
  key: 'LoadingState',
  default: false,
});

export const JoinStepState = atom<0 | 1>({
  key: 'JoinStepState',
  default: 0,
});

export const AllCheckState = atom<boolean>({
  key: 'AllCheckState',
  default: false,
});
export const TermsAgreeState = atom<number[]>({
  key: 'TermsAgreeState',
  default: [0, 0, 0, 0, 0, 0, 0, 0, 0],
});

export const CertNumberSubmitState = atom<boolean>({
  key: 'CertNumberSubmitState',
  default: false,
});

export const PartnerState = atom<PartnerInfo>({
  key: 'PartnerState',
  default: {
    PSKey: '',
    PCODE: '',
    PGroup: '',
    PName: '',
    FeeRate: 0,
    FeeType: 0,
    FeeCost: 0,
    RewardAPI: '',
    RewardURI: '',
    DelayRewardMin: 0,
    Image1: '',
    Image2: '',
    JoinURL: '',
    FontSize: '13.5px',
    FontColor: '#da2f31',
    NotiContent:
    "매월 부가세포함 2,200원 <br>본 서비스는 SKT, KT, LGU+  통신요금에 포함되어 매월 부과됩니다.",
    ButtonMsgBefore: '휴대폰분실보호 유료가입하기',
    ButtonMsgAfter: '휴대폰분실보호 유료가입하기',
    UiType: '',
    UiData: defaultUiStyle,
    SKTJoin: 'Y',
    KTJoin: 'Y',
    LGUPJoin: 'Y',
    JoinBlockMsg: '',
  },
});

export const TermsListState = atom<JoinTerms[]>({
  key: 'TermsListState',
  default: [
    // SKT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // KT
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    },
    // LGUP
    {
      TermsIdx: 0,
      Terms: [],
      TermsOrder: ""
    }
  ]
});

export const PartnerEventState = atom<PartnerEventInfo | null>({
  key: 'PartnerEventState',
  default: null,
});

export const TermsSelector = selector({
  key: 'TermsSelector',
  get: ({ get }) => get(TermsListState)?.[get(TelecomTypeState)],
});

// 필수약관 동의 여부
export const IsAgreeAllRequiredTermsSelector = selector({
  key: 'IsAgreeAllRequiredTermsSelector',
  get: ({ get }) => get(TermsSelector)?.Terms
    .filter((terms) => terms.Required === 1 && terms.Order !== undefined)
    .every((terms) => get(TermsAgreeState)[terms.Order! - 1] === 1) ?? false,
})

export const RecoilUiList  = selector({
  key: 'RecoilUiList',
  get: ({ get }) => {
    return {
      certNumberSubmit: get(CertNumberSubmitState),
      joinStep: get(JoinStepState),
      partner: get(PartnerState),
      termsList: get(TermsListState),
      termsData: get(TermsSelector),
      termsAgree: get(TermsAgreeState),
      isAgreeAllRequiredTerms: get(IsAgreeAllRequiredTermsSelector),
    }
  }
});